import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ModalState {
  isOpen: boolean;
  roleName: string | null;
}

const initialState: ModalState = {
  isOpen: false,
  roleName:"",

};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
    setRoleName: (state, action: PayloadAction<string>) => {
      state.roleName = action.payload;
    },
  },
});

export const { openModal, closeModal,setRoleName } = modalSlice.actions;
export default modalSlice.reducer;
